import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { YesNoRadioGroup } from '~/shadcn/ui/yes-no-radio-group'
import { InfoCardWrapper } from '~/@mid_ui/info-card-wrapper/InfoCardWrapper'
import { InfoIcon } from '~/@mid_ui/icons/InfoIcon'
import { Text } from '~/@mid_ui/typography/Text'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepSophisticated } from '../form-step-sophisticated/useFormStepSophisticated'
import { useQuestionsV1 } from '../../questions'

const step1Schema = z.object({ highIncomeOrLargePortfolio: z.boolean() })

export type Step1Data = z.infer<typeof step1Schema>

export function Step1() {
  const { onStepCompleted, formData } = useFormStepSophisticated()
  const question = useQuestionsV1().sophisticated.highIncomeOrLargePortfolio

  return (
    <FormStep
      defaultValues={formData}
      schema={step1Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <InfoCardWrapper>
            <div className="flex flex-row gap-2">
              <InfoIcon className="mt-1" />
              <div className="flex flex-col gap-1">
                <Text>Ste sofistikovaný investor so skúsenosťami?</Text>
                <Text className="text-sm leading-normal font-medium">
                  Aby ste sa kvalifikoval ako sofistikovaný investor, odpovedzte
                  na nasledujúce otázky.
                </Text>
              </div>
            </div>
          </InfoCardWrapper>
          <StepTitle>{question.question.label}</StepTitle>
          <Text className="font-medium">
            Vrátane hotovostných vkladov a finančných nástrojov a aktív
          </Text>
          <Controller
            control={control}
            name="highIncomeOrLargePortfolio"
            render={({ field }) => (
              <YesNoRadioGroup
                value={field.value}
                labelYes={question.answers.true.label}
                labelNo={question.answers.false.label}
                onValueChange={field.onChange}
              />
            )}
          />
        </>
      )}
    />
  )
}
